import { Typography } from "@material-ui/core";
import React from 'react';

const chavesAntecedentesCriminais = [
  'CONSULTA_CRIMINAL_VALIDADE_DIAS',
  'CONSULTA_MOTORISTA_NOVO',
  'CONSULTA_MERCADORIA_ESPECIFICA',
  'CONSULTA_PENDENTE_COMERCIAL',
];

export const Warning = ({chave}) => {
  if (chave === 'RENOVACAO_AUTOMATICA') {
    return (
      <Typography variant="caption">
        Utilizar 0 para não e 1 para sim
      </Typography>
    )
  }

  if (chavesAntecedentesCriminais.includes(chave)) {
    return (
      <Typography variant="caption">
        Utilizar EAGLE, KLIOS ou SEM_CONSULTA
      </Typography>
    )
  }

  return null
}
